import React from 'react';
import { ChevronUp } from 'lucide-react';
import { ReminderTabContent } from './ReminderComponents';
import { useNavigate } from 'react-router-dom';

const SummaryPanel = ({
  activeTab,
  isGeneratingSummary,
  conversationSummary,
  emotionalInsights,
  summaryHeader,
  displayedHeader,
  displayedSummary,
  displayedInsights,
  isAutoSaved,
  activeReminders,
  onClose,
  onDownload,
  onViewJournal,
  onCancelReminder,
  reminderService
}) => {
    const navigate = useNavigate();
  const navigateToJournal = () => {
    navigate('/journal');
  };
  return (
    <div className="search-dropdown-overlay">
      <div className="search-dropdown">
        <div className="dropdown-header">
          <div className="dropdown-title">
            <div className="ai-summary-icon">
              {activeTab === 'reminders' ? (
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5.365V3m0 2.365a5.338 5.338 0 0 1 5.133 5.368v1.8c0 2.386 1.867 2.982 1.867 4.175 0 .593-.399 1.292-1.867 1.292H6.867C5.399 18 5 17.301 5 16.708c0-1.193 1.867-1.789 1.867-4.175v-1.8A5.338 5.338 0 0 1 12 5.365Z"/>
                </svg>
              ) : isGeneratingSummary ? (
                <div className="loading-spinner"></div>
              ) : (
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"></path>
                </svg>
              )}
            </div>
            <div className='emma-loading-dots'>
              <span className="ai-icon-title">
                {activeTab === 'reminders' ? (
                  <span>Reminders ({activeReminders.length})</span>
                ) : isGeneratingSummary ? (
                  <span>Hang tight</span>
                ) : (
                  "My Journal"
                )}
              </span>
            </div>
          </div>
          <button
            className="dropdown-close"
            onClick={onClose}
          >
            <ChevronUp size={16} />
          </button>
        </div>

        <div className="dropdown-content">
          {/* Reminders Tab Content */}
          {activeTab === 'reminders' && (
            <div className="reminders-content">
              <ReminderTabContent
                reminders={activeReminders}
                onCancel={onCancelReminder}
                reminderService={reminderService}
              />
            </div>
          )}

          {/* Original Journal Content - only show when not on reminders tab */}
          {activeTab !== 'reminders' && (
            <>
              {/* Loading State */}
              {isGeneratingSummary && (
                <div className="dropdown-item">
                  <div className="item-text">
                    <div className="item-description">
                      Preptune is summarizing...
                    </div>
                  </div>
                </div>
              )}

              {/* Summary Section with Dynamic Header */}
              {conversationSummary && !isGeneratingSummary && (
                <div className="dropdown-item">
                  <div className="item-text">
                    {/* Dynamic Header */}
                    <div className="item-title">
                      <span className="emma-typing-text" data-text={summaryHeader}>
                        {displayedHeader}
                      </span>
                    </div>
                    {/* Summary Content */}
                    <div className="item-description emma-typing-text" data-text={conversationSummary}>
                      {displayedSummary}
                    </div>
                  </div>
                </div>
              )}

              {/* Emotional Insights Section */}
              {emotionalInsights && !isGeneratingSummary && (
                <div className="dropdown-item">
                  <div className="item-icon">
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.5 0.875C5.49797 0.875 3.875 2.49797 3.875 4.5C3.875 6.50203 5.49797 8.125 7.5 8.125C9.50203 8.125 11.125 6.50203 11.125 4.5C11.125 2.49797 9.50203 0.875 7.5 0.875ZM1 7.5C0.723858 7.5 0.5 7.72386 0.5 8C0.5 8.27614 0.723858 8.5 1 8.5H6.5V14C6.5 14.2761 6.72386 14.5 7 14.5H8C8.27614 14.5 8.5 14.2761 8.5 14V8.5H14C14.2761 8.5 14.5 8.27614 14.5 8C14.5 7.72386 14.2761 7.5 14 7.5H8.5V2C8.5 1.72386 8.27614 1.5 8 1.5H7C6.72386 1.5 6.5 1.72386 6.5 2V7.5H1Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <div className="item-text">
                    <div className="item-title">Emotional Insights</div>
                    <div className="item-description emma-typing-text" data-text={emotionalInsights}>
                      {displayedInsights}
                    </div>
                  </div>
                </div>
              )}

              {/* Action Buttons */}
              {!isGeneratingSummary && (conversationSummary || emotionalInsights) && (
                <div className="dropdown-item summary-actions">
                  <div className="item-text">
                    <div className="item-title">Actions</div>
                    <div className="summary-buttons">
                      {/* Auto-saved indicator */}
                      {isAutoSaved && (
                        <div className="summary-btn success">
                          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"/>
                          </svg>
                          <span>Auto-saved</span>
                        </div>
                      )}

                      {/* View Journal Button */}
                      <button
                        className="summary-btn primary"
                        onClick={navigateToJournal}

                      >
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 2C2.44772 2 2 2.44772 2 3V12C2 12.5523 2.44772 13 3 13H12C12.5523 13 13 12.5523 13 12V8.5C13 8.22386 12.7761 8 12.5 8C12.2239 8 12 8.22386 12 8.5V12H3V3L6.5 3C6.77614 3 7 2.77614 7 2.5C7 2.22386 6.77614 2 6.5 2H3ZM12.8536 2.14645C12.9015 2.19439 12.9377 2.24964 12.9621 2.30861C12.9861 2.36669 12.9996 2.4303 13 2.497L13 2.5V2.50049V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3.70711L6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355C5.95118 8.65829 5.95118 8.34171 6.14645 8.14645L11.2929 3H9.5C9.22386 3 9 2.77614 9 2.5C9 2.22386 9.22386 2 9.5 2H12.4999H12.5C12.5678 2 12.6324 2.01349 12.6914 2.03794C12.7504 2.06234 12.8056 2.09851 12.8536 2.14645Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"/>
                        </svg>
                        View
                      </button>

                      <button className="summary-btn secondary" onClick={onDownload}>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"/>
                        </svg>
                        Download
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Empty state when no content and not generating */}
              {!isGeneratingSummary && !conversationSummary && !emotionalInsights && (
                <div className="dropdown-item">
                  <div className="item-text">
                    <div className="item-title">No Content</div>
                    <div className="item-description">Start a conversation to generate your journal summary.</div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SummaryPanel;